module.exports = __webpack_public_path__ + "static/media/W19-0853_Wild_Cod_Desktop_Image_EN_2396x1473.3e15cbef.jpg";